var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCopyIconSmall = function SvgCopyIconSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.826 3.727a.25.25 0 0 1 .25-.25h5.08a.25.25 0 0 1 .168.064l2.616 2.354a.25.25 0 0 1 .083.186v7.282a.25.25 0 0 1-.25.25H8.076a.25.25 0 0 1-.25-.25V3.727Zm.25-1.75a1.75 1.75 0 0 0-1.75 1.75v1.159h-1.16a1.75 1.75 0 0 0-1.75 1.75v9.636c0 .966.784 1.75 1.75 1.75h6.728a1.75 1.75 0 0 0 1.75-1.75v-1.16h2.129a1.75 1.75 0 0 0 1.75-1.75V6.082c0-.496-.211-.969-.58-1.3l-2.616-2.355a1.75 1.75 0 0 0-1.17-.45H8.075Zm4.068 13.136H8.076a1.75 1.75 0 0 1-1.75-1.75V6.386h-1.16a.25.25 0 0 0-.25.25v9.636c0 .138.112.25.25.25h6.728a.25.25 0 0 0 .25-.25v-1.16Z",
    clipRule: "evenodd"
  })));
};
export { SvgCopyIconSmall as ReactComponent };